// Може ли този потребител да отвори съседната справка.
//
// Дашбордът сочи към пет други справки, всяка зад СВОЕ право. Без проверка
// линкът се рендира винаги, а `Reports.tsx` веднага пренасочва обратно — URL-ът
// мига и екранът не се сменя. По-честно е линкът просто да го няма.

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "../../../store/hooks";

/** Правото, зад което стои всяка справка (огледало на PAGES в Reports.tsx). */
const PERMISSION_BY_SLUG: Record<string, string> = {
  dashboard: "view_dashboard",
  "bills-history": "view_tables_history",
  "bills-splits": "view_split_tables",
  assortment: "view_assortments_report",
  cancellations: "view_voids",
  clients: "view_discounts_report",
  "price-changes": "view_price_changes_report",
  waiters: "view_waiters_report",
  stations: "view_sites_report",
  "card-payments": "view_tables_history",
  "kitchen-monitors": "view_kitchen_monitors_report",
  invoices: "view_invoices",
  "reservations-journal": "view_reservations_journal_report",
  "reservations-occupancy": "view_reservations_occupancy_report",
  "reservations-guests": "view_reservations_guests_report",
};

/**
 * Връща `null`, когато справката е недостъпна — тогава картата не рисува линк.
 * Иначе връща функция, която отваря справката, пазейки текущия `?date=`.
 */
export const useReportLink = (slug: string): (() => void) | null => {
  const navigate = useNavigate();
  const permissions = useAppSelector((state) => state.auth.permissions);
  const needed = PERMISSION_BY_SLUG[slug];
  const allowed = permissions.some((permission) => permission.name === needed);

  const go = useCallback(
    () => navigate(`/reports/${slug}${window.location.search}`),
    [navigate, slug],
  );

  return allowed ? go : null;
};
